export default "__VITE_ASSET__C$74tW$3__"